<div class="page-header">
    <h1 class="page-header__title">{{ "claim-categories.title" | translate }}</h1>
</div>

<app-claim-category-overview-table [data]="(tableData$ | async)!" (onQueryParamsChange)="onQueryParamsChange($event)" />